<!--
 * @Description: 教职工多条查找带回
 * @Author: PF
 * @Date: 2023-02-03 15:00:22
 * @LastEditors: PF
 * @LastEditTime: 2025-12-22 15:13:44
-->
<template>
  <div class="cha-zhao-duo-tiao">
    <el-dialog style="min-width: 770px;" class="wp70 hp70" :model-value="openDuoTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">教职工</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDuoTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-row style="height: 100%;">
        <el-col :span="11" style="height: 100%">
          <el-container>
            <el-header style="padding:0">
              <el-form class="search" :model="dataGrid.parms" @submit.enter.prevent>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item>
                      <el-input placeholder="工号/姓名" v-model="dataGrid.parms.keyword" clearable @clear="initLeftList()" @keyup.enter="initLeftList()">
                        <template #suffix>
                          <el-icon class="el-input__icon pointer" @click="initLeftList()">
                            <search />
                          </el-icon>
                        </template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-cascader placeholder="机构" v-model="dataGrid.parms.jgid" :options="jgTree" :props="{ label: 'jgmc', value: 'id', children: 'children'}" clearable filterable @change="initLeftList()" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-select placeholder="职务" v-model="dataGrid.parms.zwid" clearable filterable @change="initLeftList()">
                        <el-option v-for="item in zwList" :key="item.id" :label="item.zwmc" :value="item.id" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-button class="wp100" type="success" @click="openGaoJiChaXunJiaoShi=true"><span class="el-icon--left iconfont icon-sousuo" :style="dataGrid.parms.gaoJiQuery?'color:#ff0':''"></span>高级查询</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </el-header>
            <el-main style="padding:0">
              <el-table :data="dataGrid.data" border v-loading="dataGrid.loading" height="100%" @selection-change="leftSelectionChange" @row-dblclick="leftRowDblclick">
                <el-table-column type="selection" align="center" width="55" />
                <el-table-column label="工号" prop="gh" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="姓名" prop="xm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                  <template #default="scope">
                    <span style="color: #409EFF;cursor: pointer;" @click="openDetail=true; row=scope.row">{{scope.row.xm}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="性别" prop="xb" align="center" show-overflow-tooltip />
                <el-table-column label="主要职务" align="center" min-width="150" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                  <template #default="scope">
                    {{scope.row.zygwjgmc}}
                    <span v-if="scope.row.zygwjgmc && scope.row.zygwzwmc"> - </span>
                    {{scope.row.zygwzwmc}}
                  </template>
                </el-table-column>
                <el-table-column width="55" fixed="right" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <el-button link type="primary" @click.stop="leftRowDblclick(scope.row)">
                      <span class="iconfont icon-youjiantou"></span>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
          </el-container>
        </el-col>
        <el-col :span="2" style="height: 100%">
          <div class="but_group">
            <span class="iconfont icon-shuangjiantouzuo" @click="toLeftClick"></span>
            <span class="iconfont icon-shuangjiantouyou" @click="toRightClick"></span>
          </div>
        </el-col>
        <el-col :span="11" style="height: 100%">
          <el-table :data="rightTableData" border v-loading="dataGrid.loading" height="100%" @selection-change="rightSelectionChange" @row-dblclick="rightRowDblclick">
            <el-table-column type="selection" align="center" width="55" />
            <el-table-column width="55" fixed align="center" show-overflow-tooltip>
              <template #default="scope">
                <el-button link type="primary" :disabled="!scope.row.id" @click.stop="rightRowDblclick(scope.row)">
                  <span class="iconfont icon-zuojiantou"></span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="工号" prop="gh" fixed align="center" show-overflow-tooltip />
            <el-table-column label="姓名" prop="xm" fixed align="center" show-overflow-tooltip>
              <template #default="scope">
                <span style="color: #409EFF;cursor: pointer;" @click="openDetail=true; row=scope.row">{{scope.row.xm}}</span>
              </template>
            </el-table-column>
            <el-table-column label="主要职务" align="center" min-width="150" show-overflow-tooltip>
              <template #default="scope">
                {{scope.row.zygwjgmc}}
                <span v-if="scope.row.zygwjgmc && scope.row.zygwzwmc"> - </span>
                {{scope.row.zygwzwmc}}
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <template #footer>
        <div class="dialog-footer">
          <el-row style="width: 100%">
            <el-col :span="11">
              <pagination :pagination="dataGrid.pagination" @ReturnData="initLeftList" />
            </el-col>
            <el-col :span="2">
            </el-col>
            <el-col :span="11" style="display: flex;align-items: center;justify-content: space-between;">
              <span style="font-size: 14px;">共 {{ rightTableData.length }} 条</span>
              <div class="footer_but">
                <el-button type="primary" @click="savestudent()">选择</el-button>
                <el-button type="info" @click="closeWindow('openDuoTiao', emits, false)">关闭</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>
  </div>
  <gaojichaxunjiaoshi v-if="openGaoJiChaXunJiaoShi" v-model:openGaoJi="openGaoJiChaXunJiaoShi" :row="dataGrid.parms.gaoJiQuery" @ReturnData="jiaoShiGaoJiRet" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { closeWindow, loadList, loadSelect, actionPost } from '@/api/common.js'
import { loadJiGouCascader } from '@/api/queryJiGou.js'
import pagination from '@/components/pagination.vue'
import gaojichaxunjiaoshi from '@/components/gaojichaxun/jiaoshi.vue'
import detail from '@/components/jiaozhigong/detail'

const props = defineProps({
  openDuoTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDuoTiao', 'ReturnData'])

// 教师高级查询
const openGaoJiChaXunJiaoShi = ref(false)
const jiaoShiGaoJiRet = (data) => {
  dataGrid.value.parms = {}
  if (data.length !== 0) {
    dataGrid.value.parms.gaoJiQuery = data
  }
  initLeftList()
}

const openDetail = ref(false)
const row = ref()

const ids = ref([]) // 已选id
const rightTableData = ref([]) // 右侧列表
const leftMultipleSelection = ref([]) // 左侧多选
const rightMultipleSelection = ref([]) // 右侧多选
const jgTree = ref() // 加载 机构 级联下拉框
const zwList = ref() // 加载 职务 下拉框

const savestudent = () => {
  emits('ReturnData', rightTableData.value)
  closeWindow('openDuoTiao', emits, false)
}
// 双击左侧列表
const leftRowDblclick = (row) => {
  leftMultipleSelection.value.push(row)
  toRightClick()
}
// 双击右侧列表
const rightRowDblclick = (row) => {
  rightMultipleSelection.value.push(row)
  toLeftClick()
}
// 左箭头
const toLeftClick = () => {
  if (rightMultipleSelection.value.length) {
    rightMultipleSelection.value.forEach((element) => {
      dataGrid.value.data.unshift(element)
      rightTableData.value.forEach((e, index) => {
        if (e.id === element.id) {
          rightTableData.value.splice(index, 1)
        }
      })
    })
    if (rightTableData.value) {
      ids.value = rightTableData.value.map((item) => item.id)
    }
    initLeftList()
    initRightList()
    rightMultipleSelection.value = []
  }
}
// 右箭头
const toRightClick = () => {
  if (leftMultipleSelection.value.length) {
    leftMultipleSelection.value.forEach((element) => {
      rightTableData.value.push(element)
      dataGrid.value.data.forEach((e, index) => {
        if (e.id === element.id) {
          dataGrid.value.data.splice(index, 1)
        }
      })
    })
    if (rightTableData.value) {
      ids.value = rightTableData.value.map((item) => item.id)
    }
    initLeftList()
    initRightList()
    leftMultipleSelection.value = []
  }
}
// 左侧复选框
const leftSelectionChange = (val) => {
  leftMultipleSelection.value = []
  if (val.length) {
    val.forEach((element) => {
      leftMultipleSelection.value.push(element)
    })
  }
}
// 右侧复选框
const rightSelectionChange = (val) => {
  rightMultipleSelection.value = []
  if (val.length) {
    val.forEach((element) => {
      rightMultipleSelection.value.push(element)
    })
  }
}

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'gh', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    initLeftList()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const initLeftList = async (pageNo, pageSize) => {
  dataGrid.value.parms.jgid = Array.isArray(dataGrid.value.parms.jgid)
    ? dataGrid.value.parms.jgid[dataGrid.value.parms.jgid.length - 1]
    : dataGrid.value.parms.jgid
  dataGrid.value.parms.notInIDs = ids.value

  loadList({
    url: '/api/v2/pdp/jiaozhigong/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

const initRightList = async () => {
  rightTableData.value = []
  dataGrid.value.loading = true
  const o = {
    url: '/api/v2/pdp/jiaozhigong/list',
    data: { order: 'gh', sort: 'asc', inIDs: ids.value }
  }
  actionPost(o).then((res) => {
    dataGrid.value.loading = false
    rightTableData.value = res.data // 返回列表
  })
}
watch(
  () => props.openDuoTiao,
  () => {
    if (props.openDuoTiao) {
      ids.value = props.row.ids || []
      dataGrid.value.parms.kqfzSign = props.row.kqfzSign || undefined
      initLeftList()
      initRightList()
      loadJiGouCascader(jgTree)
      loadSelect({ url: '/api/v2/pdp/zhiwu/list', data: zwList })
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
:deep(.filter-item) {
  width: 150px;
}
.search {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .el-button {
    margin: 0;
  }
}
:deep(.el-radio__label) {
  display: none;
}
:deep(.el-tabs__content) {
  display: none;
}
.el-tabs {
  height: 55px;
}
:deep(.but_group) {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  .iconfont {
    font-size: 1.5rem;
    cursor: pointer;
  }
}
.e-row {
  height: 100%;
}
</style>
